// extracted by mini-css-extract-plugin
module.exports = {"border":"Table_border__35Yd_","table":"Table_table__3RBpO","link":"Table_link__356YE"};